<template>
    <div
        v-if="calendarInCart"
        class="cz2__review-views__view-calendar"
    >
        <button
            type="button"
            @click="openCalendarModal"
            aria-label="View holiday calendar info"
            class="cz2__review-views__view cz2__review-views__view--active"
        >
            <span
                class="cz2__review-views__view-image"
                :style="{
                    backgroundImage: `url(${calendarPreviewImage})`,
                }"
            />
        </button>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__review-views__view-calendar {
            border-top: 1px solid rgba(141, 186, 237, 0.3);
            padding-top: 16px;

            .cz2__review-views__view {
                padding: 0 4px;
                background-color: white !important;
            }

            @include respond-above(lg) {
                margin-top: 4px;
            }
        }
    }

    #cz2.cz2.cz2__is-name-step {
        .cz2__review-views__view-calendar {
            margin-top: 0;
            border-top: none;
            padding-top: 0;

            margin-left: 4px;
            border-left: 1px solid rgba(141, 186, 237, 0.3);
            padding-left: 20px;

            @include respond-above(md) {
                margin-left: 0;
                border-left: none;
                padding-left: 0;

                margin-top: 4px;
                border-top: 1px solid rgba(141, 186, 237, 0.3);
                padding-top: 16px;
            }
        }
    }
</style>

<script>
    export default {
        computed: {
            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },

            calendarInCart() {
                return this.$store.getters.holidayCalendarInCart;
            },

            calendarPreviewImage() {
                const image = this.globalSettings?.['fun-splash-holiday-calendar-image'];

                return `${image}?fmt=webp&qlt=70`;
            },
        },

        methods: {
            openCalendarModal() {
                this.$store.dispatch('setShowCalendarModal', true);
            },
        },
    };
</script>
